<template>
  <div name="hres6oe-history-detail" class="checkin-google-map history-detail-wrapper">
    <div class="history-header">
      <div class="panel-left">
        <div class="header-row -topic">
          <i class="fa fa-building" aria-hidden="true"></i>{{data.namcust}}
        </div>
        <div class="header-row">
          <i class="fa fa-calendar" aria-hidden="true"></i>{{data.dtein}} - {{data.dteout}}
        </div>
        <div class="header-row">
          <i class="fa fa-clock-o" aria-hidden="true"></i>{{data.timin}} - {{data.timout}}
        </div>
      </div>
      <div v-if="data.flgcanedit === 'Y' && !flgEdit" class="panel-right">
        <img class="img cursor-pointer" :src="'/static/images/checkin/weekly_icon.png'" @click="callEditDetail()">
      </div>
    </div>
    <div class="history-detail" v-show="!flgEdit">
      <div v-if="(data.typplace === '3')" class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['40']}} :</div>
        <div class="data-box">{{data.new_namcust}}</div>
      </div>
      <div v-if="(data.typplace === '3')" class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['50']}} :</div>
        <div class="data-box">{{data.namcontact}}</div>
      </div>
      <div v-if="(data.typplace === '3')" class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['60']}} :</div>
        <div class="data-box">{{data.phone}}</div>
      </div>
      <div class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['20']}} :</div>
        <div class="data-box">{{data.namreason}}</div>
      </div>
      <div class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['30']}} :</div>
        <div class="data-box">{{data.activity}}</div>
      </div>
      <div class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['80']}} :</div>
      </div>
      <div v-if="data.filenamei && pathImage" class="checkin-image">
        <img :src="pathImage + data.filenamei" >
      </div>
      <div class="detail-set">
        <div class="label-box">{{label['HRES6OEC4']['90']}} :</div>
      </div>
      <div v-if="data.filenameo && pathImage" class="checkin-image">
        <img :src="pathImage + data.filenameo" >
      </div>
    </div>
    <div class="panel-edit" v-show="flgEdit">
      <div v-if="(detail.typplace === '3')">
        <div class="input-group">
          <div class="label">{{label['HRES6OEC4']['40']}} <span class="text-red">*</span></div>
          <input  v-model="detail.new_namcust"
                  class="normal-input"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="new_namcust"
                  name="input"
                  :has-error="errors.has('new_namcust')" />
          <div class="validator-text -error" v-show="errors.has('new_namcust')">{{errors.first('new_namcust')}}</div>
        </div>
        <div class="input-group">
          <div class="label">{{label['HRES6OEC4']['50']}} <span class="text-red">*</span></div>
          <input  v-model="detail.namcontact"
                  class="normal-input"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="namcontact"
                  name="input"
                  :has-error="errors.has('namcontact')" />
          <div class="validator-text -error" v-show="errors.has('namcontact')">{{errors.first('namcontact')}}</div>
        </div>
        <div class="input-group">
          <div class="label">{{label['HRES6OEC4']['60']}} <span class="text-red">*</span></div>
          <input  v-model="detail.phone"
                  class="normal-input"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="phone"
                  name="input"
                  :has-error="errors.has('phone')" />
          <div class="validator-text -error" v-show="errors.has('phone')">{{errors.first('phone')}}</div>
        </div>
      </div>
      <div class="input-group">
        <div class="label">{{label['HRES6OEC4']['20']}} <span class="text-red">*</span></div>
        <hrms-dropdown  v-model="detail.codreason"
                        :options="dropdowns"
                        v-validate="'required'"
                        data-vv-value-path="inputValue"
                        data-vv-name="codreason"
                        :has-error="errors.has('codreason')" />
        <div class="validator-text -error" v-show="errors.has('codreason')">{{errors.first('codreason')}}</div>
      </div>
      <div class="input-group">
        <div class="label">{{label['HRES6OEC4']['30']}} <span class="text-red">*</span></div>
        <textarea v-model="detail.activity"
                  class="normal-input"
                  type="text"
                  name="input"
                  style="height: 200px;"
                  maxlength="500" 
                  v-validate="'required|max:500'"
                  data-vv-name="activity"
                  :has-error="errors.has('activity')" >
        </textarea>
        <div class="validator-text -error" v-show="errors.has('activity')">{{errors.first('activity')}}</div>
        <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
      </div>
    </div>
    <div class="panel-button">
      <div v-show="!flgEdit" class="button-md _bg-grey" :class="pcDisp ? '' : '-mobile'" @click="callBack()">Back</div>
      <div v-show="flgEdit" class="button-md _bg-green" :class="pcDisp ? '' : '-mobile'" @click="callSave()">Save</div>
      <div v-show="flgEdit" class="button-md _bg-grey" :class="pcDisp ? '' : '-mobile'" @click="callCancel()">Cancel</div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres6oe-history-detail',
  props: [
    'data',
    'label',
    'toggle',
    'dropdowns',
    'currentUser',
    'saveCheckInDetail',
    'pathImage',
    'pcDisp'
  ],
  data () {
    return {
      detail: {
        codreason: '',
        namreason: '',
        activity: '',
        codcust: '',
        dtework: '',
        seqno: '',
        namcust: '',
        dtein: '',
        dayweek: '',
        day: '',
        timin: '',
        dteout: '',
        timout: '',
        new_namcust: '',
        phone: ''
      },
      flgEdit: false
    }
  },
  watch: {
    'data.codreason' () {
      this.detail.namreason = this.dropdowns[this.detail.codreason]
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    paramSave () {
      this.detail.codempid = this.currentUser.p_codempid
      // this.detail.codempid = '16010' // for demo
      return this.detail
    },
    callEditDetail (index) {
      this.detail = Object.assign({}, this.data)
      this.flgEdit = true
    },
    callCancel () {
      this.detail = Object.assign({}, this.data)
      this.flgEdit = false
    },
    callBack () {
      this.toggle('history')
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.saveCheckInDetail({saveParams: this.paramSave(), searchParams: this.currentUser.p_codempid})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// historyDetail.vue?2bbaf57a